export default __webpack_public_path__ + "static/media/literoflight.d240e44e.jpg";